import React from "react";
import { Box, Break, Link, Text } from "~/components-shared";
import { CollapsableTypeEnum, TopicFootprintTypeEnum } from "~/types/enums";
import Collapsable from "~/components/Collapsable";
import FootprintActions from "~/components/FootprintActions";
import Markdown from "~/components/Markdown";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
const StyledBox = styled(Box)`
  padding-left: 1em;
  position: relative;

  &:before {
    position: absolute;
    content: "";
    left: 0;
    top: 0;
    width: 3px;
    height: 100%;
    background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.primary.main;
}};
    border-radius: 3px;
  }
`;
const TopicFootprintContentConfluence = _ref2 => {
  let {
    footprint,
    hideDetails,
    hideMessage
  } = _ref2;
  const {
    t
  } = useTranslation();
  const {
    actions,
    type,
    data,
    aiAnalysis
  } = footprint;
  if ([TopicFootprintTypeEnum.PAGE].includes(type)) {
    const {
      pageTitle,
      pageUrl,
      pageBody,
      ownerName
    } = data;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold"
    }, /*#__PURE__*/React.createElement(FootprintActions, {
      actions: actions
    }), " a Confluence", " ", /*#__PURE__*/React.createElement(Link, {
      href: pageUrl,
      underline: true
    }, "page"), !!ownerName && /*#__PURE__*/React.createElement(React.Fragment, null, " owned by ", ownerName)), /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4.5,
      lineHeight: 6,
      display: "block",
      s: {
        mt: 1,
        mb: 2
      }
    }, pageTitle), aiAnalysis?.summary && /*#__PURE__*/React.createElement(Text, {
      fontSize: 4,
      s: {
        mb: 1
      },
      lineHeight: 6,
      display: "block"
    }, aiAnalysis.summary), aiAnalysis?.changes && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4,
      lineHeight: 6.5,
      display: "block",
      s: {
        mt: 5,
        mb: 1
      }
    }, t("TopicFootprintContentConfluence.whatHasChanged")), /*#__PURE__*/React.createElement(Collapsable, null, /*#__PURE__*/React.createElement(Markdown, {
      fontSize: 4,
      s: {
        mb: 1
      },
      lineHeight: 6,
      display: "block",
      text: aiAnalysis.changes
    })))), !hideMessage && pageBody && /*#__PURE__*/React.createElement(Collapsable, {
      maxHeight: 0,
      type: CollapsableTypeEnum.BUTTON,
      s: {
        mb: 3
      },
      collapsedText: "View page content",
      expandedText: "Hide page content"
    }, /*#__PURE__*/React.createElement(Break, {
      s: {
        mt: 1,
        mb: 3
      },
      style: {
        maxWidth: "120px"
      }
    }), /*#__PURE__*/React.createElement(Markdown, {
      fontSize: 4,
      lineHeight: 6,
      display: "block",
      text: `<div>${pageBody}</div>`
    })));
  }
  if ([TopicFootprintTypeEnum.COMMENT].includes(type)) {
    const {
      pageTitle,
      commentUrl,
      ownerName,
      pageBody,
      commentBody,
      commentStatus
    } = data;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold"
    }, /*#__PURE__*/React.createElement(FootprintActions, {
      actions: actions
    }), " a Confluence", " ", /*#__PURE__*/React.createElement(Link, {
      href: commentUrl,
      underline: true
    }, "page"), !!ownerName && /*#__PURE__*/React.createElement(React.Fragment, null, " owned by ", ownerName)), /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4.5,
      lineHeight: 6,
      display: "block",
      s: {
        mt: 1,
        mb: 2
      }
    }, pageTitle), aiAnalysis?.summary && /*#__PURE__*/React.createElement(Text, {
      fontSize: 4,
      s: {
        mb: 1
      },
      lineHeight: 6,
      display: "block"
    }, aiAnalysis.summary)), !hideMessage && /*#__PURE__*/React.createElement(React.Fragment, null, pageBody && /*#__PURE__*/React.createElement(Collapsable, {
      maxHeight: 0,
      type: CollapsableTypeEnum.BUTTON,
      s: {
        mb: 3
      },
      collapsedText: "View page content",
      expandedText: "Hide page content"
    }, /*#__PURE__*/React.createElement(Break, {
      s: {
        mt: 1,
        mb: 3
      },
      style: {
        maxWidth: "120px"
      }
    }), /*#__PURE__*/React.createElement(Markdown, {
      fontSize: 4,
      lineHeight: 6,
      display: "block",
      text: `<div>${pageBody}</div>`
    })), commentBody && /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement(Collapsable, null, commentStatus && /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 3,
      color: "textSecondary",
      display: "block"
    }, "Status: ", commentStatus), /*#__PURE__*/React.createElement(Markdown, {
      text: `<div>${commentBody}</div>`,
      fontSize: 4,
      lineHeight: 6,
      display: "block"
    })))));
  }
  return /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold"
  }, "Unknown event");
};
export default TopicFootprintContentConfluence;